import { toTableCellTextFromName } from '../../Table.utils'

export function toPhasesCellValue(value) {
  return value
    ? [
        toTableCellTextFromName(value),
        ...Array.from({ length: value.count - 1 }),
      ]
    : null
}
